import FormatAlignCenter from '@mui/icons-material/FormatAlignCenter';
import FormatAlignJustify from '@mui/icons-material/FormatAlignJustify';
import FormatAlignLeft from '@mui/icons-material/FormatAlignLeft';
import FormatAlignRight from '@mui/icons-material/FormatAlignRight';
import FormatBold from '@mui/icons-material/FormatBold';
import FormatItalic from '@mui/icons-material/FormatItalic';
import FormatListBulleted from '@mui/icons-material/FormatListBulleted';
import FormatListNumbered from '@mui/icons-material/FormatListNumbered';
import FormatUnderlined from '@mui/icons-material/FormatUnderlined';
import StrikethroughS from '@mui/icons-material/StrikethroughS';
import React from 'react';
import { EditorToolbarButton } from './EditorToolbarButton';
// import TextStyleControl from './TextStyleControl';
// import CreateLinkButton from './CreateLinkButton';

import { type Editor } from "@tiptap/react"

export type EditorToolbarProps = {
  disabled?: boolean;
  editor: Editor;
};

export function EditorToolbar(props: EditorToolbarProps) {
  const { disabled, editor } = props;

  return (
    <>
      {/* <TextStyleControl disabled={disabled} editor={editor} /> */}

      {/* Alignment */}
      <EditorToolbarButton
        data-testid="rich-text-align-left"
        disabled={disabled}
        isActive={editor.isActive({ textAlign: 'left' })}
        onClick={() => chainFocus(editor, (chain: any) => chain.setTextAlign('left'))}
      >
        <FormatAlignLeft />
      </EditorToolbarButton>
      <EditorToolbarButton
        data-testid="rich-text-align-center"
        disabled={disabled}
        isActive={editor.isActive({ textAlign: 'center' })}
        onClick={() => chainFocus(editor, (chain: any) => chain.setTextAlign('center'))}
      >
        <FormatAlignCenter />
      </EditorToolbarButton>
      <EditorToolbarButton
        data-testid="rich-text-align-right"
        disabled={disabled}
        isActive={editor.isActive({ textAlign: 'right' })}
        onClick={() => chainFocus(editor, (chain: any) => chain.setTextAlign('right'))}
      >
        <FormatAlignRight />
      </EditorToolbarButton>
      <EditorToolbarButton
        data-testid="rich-text-align-justify"
        disabled={disabled}
        isActive={editor.isActive({ textAlign: 'justify' })}
        onClick={() => chainFocus(editor, (chain: any) => chain.setTextAlign('justify'))}
      >
        <FormatAlignJustify />
      </EditorToolbarButton>

      {/* Bold, italic, underline, strikethrough */}
      <EditorToolbarButton
        data-testid="rich-text-bold"
        disabled={disabled}
        isActive={editor.isActive('bold')}
        onClick={() => chainFocus(editor, (chain: any) => chain.toggleBold())}
      >
        <FormatBold />
      </EditorToolbarButton>
      <EditorToolbarButton
        data-testid="rich-text-italic"
        disabled={disabled}
        isActive={editor.isActive('italic')}
        onClick={() => chainFocus(editor, (chain: any) => chain.toggleItalic())}
      >
        <FormatItalic />
      </EditorToolbarButton>
      <EditorToolbarButton
        data-testid="rich-text-underline"
        disabled={disabled}
        isActive={editor.isActive('underline')}
        onClick={() => chainFocus(editor, (chain: any) => chain.toggleUnderline())}
      >
        <FormatUnderlined />
      </EditorToolbarButton>
      <EditorToolbarButton
        data-testid="rich-text-strike"
        disabled={disabled}
        isActive={editor.isActive('strike')}
        onClick={() => chainFocus(editor, (chain: any) => chain.toggleStrike())}
      >
        <StrikethroughS />
      </EditorToolbarButton>

      {/* Lists */}
      <EditorToolbarButton
        data-testid="rich-text-bullet-list"
        disabled={disabled}
        isActive={editor.isActive('bulletList')}
        onClick={() => chainFocus(editor, (chain: any) => chain.toggleBulletList())}
      >
        <FormatListBulleted />
      </EditorToolbarButton>
      <EditorToolbarButton
        data-testid="rich-text-ordered-list"
        disabled={disabled}
        isActive={editor.isActive('orderedList')}
        onClick={() => chainFocus(editor, (chain: any) => chain.toggleOrderedList())}
      >
        <FormatListNumbered />
      </EditorToolbarButton>

      {/* <CreateLinkButton disabled={disabled} editor={editor} /> */}
    </>
  );
};

function chainFocus(editor: Editor, chainFunc: any) {
  const chain = editor.chain().focus();
  chainFunc(chain).run();
}